import { render, staticRenderFns } from "./AdminStudyMapList.vue?vue&type=template&id=16879a95&"
import script from "./AdminStudyMapList.vue?vue&type=script&lang=js&"
export * from "./AdminStudyMapList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports